
import * as R from 'ramda'
import { ANALYSIS_GROUPT_TYPE_MAP } from '@Bill/constants'
import i18n from '@/locales'
import { accountsFilterByOem } from '@/utils/utils'
import { getBrandName } from '@/utils/common/hypervisor'
import { getBillResourceTypeLabel } from '@Bill/utils'

export default {
  data () {
    const { group, domain_id } = this.$route.query
    const initGroup = group && ANALYSIS_GROUPT_TYPE_MAP[group] ? group : 'project'
    const initDomain = group === 'project' && domain_id ? [domain_id] : []
    return {
      formData: {
        groups: [
          {
            group: initGroup,
            tag: undefined,
            project_tag: undefined,
            instance_tag: undefined,
          },
        ],
        group: [initGroup],
        show_bill_type: 'only_show_bill',
        bill_type_condition: 'equals',
        platform_brand: [],
        platform_brand_condition: 'equals',
        account: [],
        account_condition: 'equals',
        linked_name: [],
        linked_name_condition: 'equals',
        cloudprovider: [],
        cloudprovider_condition: 'equals',
        region: [],
        region_condition: 'equals',
        origin_region: [],
        origin_region_condition: 'equals',
        project: [],
        project_condition: 'equals',
        domain: initDomain,
        domain_condition: 'equals',
        charge_type: undefined,
        charge_type_condition: 'equals',
        resource_type: [],
        resource_type_condition: 'equals',
        origin_res_type: [],
        origin_res_type_condition: 'equals',
        external_project_name: [],
        external_project_name_condition: 'equals',
        usage_type: [],
        usage_type_condition: 'equals',
        product_type: [],
        product_type_condition: 'equals',
        origin_usage_type: [],
        origin_usage_type_condition: 'equals',
        origin_record_type: [],
        origin_record_type_condition: 'equals',
        date: this.getDate(),
        spec: [],
        spec_condition: 'equals',
        financial_unit: [],
        financial_unit_condition: 'equals',
        tag: {},
        instance_tag: {},
        project_tag: {},
        tag_key: {},
        tag_key1: {},
        project_tag_key: {},
        project_tag_key1: {},
        instance_tag_key: {},
        instance_tag_key1: {},
        tag_val_split: '',
        operation_num: 1,
        service_period: 1,
      },
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      OPERATION_NUM_MIN: 1,
      OPERATION_NUM_MAX: 100000000,
      SERVICE_PERIOD_MIN: 1,
      SERVICE_PERIOD_MAX: 100000000,
    }
  },
  computed: {
    // dataGroupCount () {
    //   let groupCount = 1
    //   if (this.dataList[0] && this.dataList[0].data && this.dataList[0].data[0] && this.dataList[0].data[0].hasOwnProperty('name')) {
    //     groupCount = 2
    //   }
    //   return groupCount
    // },
    groupLen () {
      let len = 0
      this.formData.groups.filter(item => item.group).forEach(item => {
        if (['tag', 'instance_tag', 'project_tag'].includes(item.group)) {
          if (item[item.group]) {
            len += 1
          }
        } else {
          len += 1
        }
      })
      return len
    },
    truthGroupLen () {
      let len = 0
      this.formData.groups.filter(item => item.group && item.group !== 'aggregate_usage_unit').forEach(item => {
        if (['tag', 'instance_tag', 'project_tag'].includes(item.group)) {
          if (item[item.group]) {
            len += 1
          }
        } else {
          len += 1
        }
      })
      return len
    },
    group () {
      if (this.formData.show_bill_type === 'show_bill_usage') {
        return [...this.formData.group, 'aggregate_usage_unit']
      }
      return this.formData.group
    },
    showAsDimension1 () {
      const { date = {} } = this.formData
      return date.data_type === 'dimension' && this.truthGroupLen === 1
    },
    showAsDimension2 () {
      const { date = {} } = this.formData
      return date.data_type === 'dimension' && this.truthGroupLen > 1
    },
  },
  methods: {
    getSortData (data, property, order, billType) {
      const list = [...data]
      if (property && order) {
        list.sort((a, b) => {
          const aV = property === 'percent' ? parseFloat(a[property][billType]) : a[property][billType]
          const bV = property === 'percent' ? parseFloat(b[property][billType]) : b[property][billType]
          if (aV > bV) {
            return 1
          } else if (aV < bV) {
            return -1
          } else {
            return 0
          }
        })
        if (order === 'desc') {
          list.reverse()
        }
      }
      return list
    },
    getTagKey (key) {
      const ret = key.replace('user:', '')
      // 没有标签的资源，默认生成的
      // if (ret === 'cloud_default') {
      //   ret = this.$t('common_736')
      // }
      return ret
    },
    // 聚合groupCount=2数据到groupCount=1
    // params <Array> [{name: '1', data:[{date_info: '2021-07', stat_value: 1}, {date_info: '2021-08', stat_value: 2}]},{name: '1', data:[{date_info: '2021-07', stat_value: 1}, {date_info: '2021-08', stat_value: 2}]}]
    // return <Array> [{date_info: '2021-07', stat_value: 2}, {date_info: '2021-08', stat_value: 4}]
    // groupStatValue (list) {
    //   const ret = []
    //   if (!list[0] || !list[0].data) return ret
    //   list[0].data.map(item => {
    //     const obj = {
    //       date_info: item.date_info,
    //       stat_value: 0,
    //       stat_value_sec: 0,
    //       gross_value: 0,
    //       paid_value: 0,
    //       discount_value: 0,
    //     }
    //     list.map(level1 => {
    //       level1.data.map(level2 => {
    //         if (level2.date_info === item.date_info) {
    //           obj.stat_value += level2.stat_value || 0
    //           obj.stat_value_sec += level2.stat_value_sec || 0
    //           obj.gross_value += level2.gross_value || 0
    //           obj.paid_value += level2.paid_value || 0
    //           obj.discount_value += level2.discount_value || 0
    //         }
    //       })
    //     })
    //     ret.push(obj)
    //   })
    //   return ret
    // },
    getDate () {
      const T = time => this.$moment(time)
      const nowMonth = T(new Date()).month() + 1
      const selectMonth = T(this.month).month() + 1
      const selectDate = T(this.month).startOf('month').format('YYYY-MM-DD') + 'TZ'
      let endDate = T(this.month).endOf('month').format('YYYY-MM-DD') + 'TZ'
      if (nowMonth === selectMonth) {
        // 说明是在当前月份
        endDate = T(this.month).format('YYYY-MM-DD') + 'TZ'
      }
      return {
        start_date: selectDate,
        end_date: endDate,
        data_type: 'day',
      }
    },
    getNameI18n (name, type) {
      if (name === 'other') {
        return this.$t('bill.other')
      }
      if (type === 'resource_type') {
        return getBillResourceTypeLabel(name)
      }
      if (type === 'charge_type') {
        return i18n.te(`billingType.${name}`) ? i18n.t(`billingType.${name}`) : name
      }
      if (type === 'brand') {
        return getBrandName(name)
      }
      if (type === 'account') {
        return name === 'OneStack' ? accountsFilterByOem({ data: { name } }).name || name : name
      }
      if (type === 'tag') {
        if (!name) {
          return i18n.t('bill.null_value')
        } else if (name === '___no_value__') {
          return i18n.t('common_736')
        }
      }
      if (type === 'project_tag') {
        if (!name) {
          return i18n.t('bill.null_value')
        } else if (name === '___no_value__') {
          return i18n.t('common_736')
        }
      }
      if (type === 'instance_tag') {
        if (!name) {
          return i18n.t('bill.null_value')
        } else if (name === '___no_value__') {
          return i18n.t('common_736')
        }
      }
      return name
    },
    getSortDataBySum (dataList, valueKey) { // valueKey 可动态切换是展示应付金额还是二次定价金额
      const _dataList = R.clone(dataList)
      const { operation_num, service_period } = this.formData
      if (this.groupLen === 1) {
        for (let index = 0; index < _dataList.length; index++) {
          const item = _dataList[index]
          const stat_values = item.data.map(obj => {
            if (R.is(Number, operation_num) && R.is(Number, service_period)) {
              if (operation_num > 0 && service_period > 0) {
                obj.stat_value = obj[valueKey] / operation_num * service_period
              } else {
                obj.stat_value = obj[valueKey]
              }
            } else {
              obj.stat_value = obj[valueKey]
            }
            return obj.stat_value
          })
          const stat_value_sum = R.sum(stat_values)
          _dataList[index].stat_value_sum = stat_value_sum
        }
      } else if (this.groupLen === 2) {
        for (let index = 0; index < _dataList.length; index++) {
          const item = _dataList[index]
          const stat_values = item.data.map(obj => {
            let value = 0;
            (obj.data || []).map(l => {
              if (R.is(Number, operation_num) && R.is(Number, service_period)) {
                if (operation_num > 0 && service_period > 0) {
                  l.stat_value = l[valueKey] / operation_num * service_period
                } else {
                  l.stat_value = l[valueKey]
                }
              } else {
                l.stat_value = l[valueKey]
              }
              value += l.stat_value
            })
            return value
          })
          const stat_value_sum = R.sum(stat_values)
          _dataList[index].stat_value_sum = stat_value_sum
        }
      }
      _dataList.sort((a, b) => b.stat_value_sum - a.stat_value_sum)
      return _dataList
    },
    operationNumChangeHandle (v) {
      if (!R.is(Number, v) || v <= 0) {
        this.formData.operation_num = 1
      }
    },
    // groupChange (str) {
    //   this.formData[`tag_key${str}`] = {}
    //   this.formData[`project_tag_key${str}`] = {}
    //   this.formData[`instance_tag_key${str}`] = {}
    // },
    servicePeriodChangeHandle (v) {
      if (!R.is(Number, v) || v <= 0) {
        this.formData.service_period = 1
      }
    },
    getGroupInfo (v) {
      if (v) {
        if (v.startsWith('tag:')) {
          return {
            type: 'tag',
            value: v.replace('tag:', ''),
          }
        }
        if (v.startsWith('project_tag:')) {
          return {
            type: 'project_tag',
            value: v.replace('project_tag:', ''),
          }
        }
        if (v.startsWith('instance_tag:')) {
          return {
            type: 'instance_tag',
            value: v.replace('instance_tag:', ''),
          }
        }
      }
      return {
        type: v,
        value: null,
      }
    },
  },
}
